import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "company" }
const _hoisted_2 = { class: "p-formgroup" }
const _hoisted_3 = { class: "p-d-flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-id-card" }, null, -1)
const _hoisted_5 = { class: "p-grid" }
const _hoisted_6 = {
  class: "p-col-12 p-sm-2",
  style: {"display":"grid","place-items":"start"}
}
const _hoisted_7 = { style: {"width":"clamp(100px, 100%, 180px)"} }
const _hoisted_8 = { class: "p-col-12 p-sm-10" }
const _hoisted_9 = { class: "p-formgroup p-grid p-fluid" }
const _hoisted_10 = { class: "p-field p-col-6" }
const _hoisted_11 = { class: "p-field p-col-6" }
const _hoisted_12 = { class: "p-field p-col-6" }
const _hoisted_13 = { class: "p-field p-col-12" }
const _hoisted_14 = {
  key: 0,
  class: "p-field p-col-6"
}
const _hoisted_15 = {
  key: 1,
  class: "p-field p-col-12"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-money-bill" }, null, -1)
const _hoisted_17 = { class: "p-grid" }
const _hoisted_18 = { class: "p-field p-col-4" }
const _hoisted_19 = { class: "p-field p-col-4" }
const _hoisted_20 = {
  id: "file-upload-container",
  class: "p-field p-col-4"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-book" }, null, -1)
const _hoisted_22 = { class: "p-formgroup p-grid p-fluid" }
const _hoisted_23 = { class: "p-field p-col-6" }
const _hoisted_24 = { class: "p-field p-col-6" }
const _hoisted_25 = { class: "p-field p-col-6" }
const _hoisted_26 = { class: "p-field p-col-6" }
const _hoisted_27 = { class: "p-field p-col-6" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Brokers ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_ImageInput = _resolveComponent("ImageInput")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_CompanyAutocomplete = _resolveComponent("CompanyAutocomplete")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.requestPending && !_ctx.company)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
              return _createElementVNode("div", {
                class: "p-field p-fluid",
                key: `skeleton_${i}`
              }, [
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  class: "p-mb-2"
                })
              ])
            }), 64))
          ]),
          _createVNode(_component_Skeleton, {
            height: "5rem",
            class: "p-mb-2"
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Skeleton, {
              height: "2rem",
              width: "20rem",
              class: "p-mr-2"
            }),
            _createVNode(_component_Skeleton, {
              height: "2rem",
              width: "6rem"
            })
          ])
        ], 64))
      : (_ctx.company)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_Fieldset, null, {
              legend: _withCtx(() => [
                _hoisted_4
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_ImageInput, {
                        id: "logo",
                        name: "logo",
                        modelValue: _ctx.company.companyLogo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.company.companyLogo = $event)),
                        url: _ctx.company.logo_image_path_url
                      }, null, 8, ["modelValue", "url"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_FloatLabel, { label: "Name" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.company.name,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.company.name = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_FloatLabel, { label: "Email" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.company.email,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.company.email = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_FloatLabel, { label: "Phone" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.company.phone,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.company.phone = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('contract.notes')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Textarea, {
                              modelValue: _ctx.company.note,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.company.note = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      (_ctx.isBroker || _ctx.isClient)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_CompanyAutocomplete, {
                              label: "Customer",
                              type: _ctx.CUSTOMER_TYPE,
                              modelValue: _ctx.selectedCustomer,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedCustomer = $event)),
                              disabled: _ctx.requestPending,
                              onSelect: _ctx.addCustomer
                            }, null, 8, ["type", "modelValue", "disabled", "onSelect"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isBroker || _ctx.isClient)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_DataTable, {
                              value: _ctx.company.customers,
                              loading: _ctx.requestPending,
                              stripedRows: "",
                              rows: 10,
                              "rows-per-page-options": [10, 20, 50, 100],
                              paginator: true,
                              "auto-layout": true,
                              "striped-rows": true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  field: "business_name",
                                  header: "Business name"
                                }),
                                _createVNode(_component_Column, {
                                  field: "email",
                                  header: "Email"
                                }),
                                _createVNode(_component_Column, {
                                  field: "phone",
                                  header: "Phone"
                                }),
                                _createVNode(_component_Column, {
                                  field: "business_address",
                                  header: "Business address"
                                }),
                                _createVNode(_component_Column, {
                                  field: "business_city",
                                  header: "Business city"
                                }),
                                _createVNode(_component_Column, {
                                  header: "Actions",
                                  class: "column-header-right p-text-right",
                                  style: {"min-width":"100px","width":"100px"}
                                }, {
                                  body: _withCtx(({data}) => [
                                    (_ctx.canDeleteCompany(data.id))
                                      ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          class: "p-button-danger",
                                          icon: "pi pi-trash",
                                          onClick: _withModifiers(($event: any) => (_ctx.onRemove(data)), ["stop"])
                                        }, null, 8, ["onClick"])), [
                                          [
                                            _directive_tooltip,
                                            'Remove customer',
                                            void 0,
                                            { bottom: true }
                                          ]
                                        ])
                                      : _createCommentVNode("", true),
                                    _renderSlot(_ctx.$slots, "actions", { data: data })
                                  ]),
                                  _: 3
                                })
                              ]),
                              _: 3
                            }, 8, ["value", "loading"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _: 3
            }),
            (_ctx.isBroker)
              ? (_openBlock(), _createBlock(_component_Fieldset, {
                  key: 0,
                  class: "p-mt-4"
                }, {
                  legend: _withCtx(() => [
                    _hoisted_16
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_FloatLabel, { label: "Insurance policy number" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              style: {"width":"100%"},
                              modelValue: _ctx.company.insurance,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.company.insurance = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_FloatLabel, { label: "Expiry date" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Calendar, {
                              style: {"width":"100%"},
                              modelValue: _ctx.company.insurance_expiry,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.company.insurance_expiry = $event)),
                              showIcon: true,
                              showTime: false,
                              dateFormat: 'yy-mm-dd'
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('company.document')) + ":", 1),
                        _createElementVNode("div", null, [
                          _createVNode(_component_FileInput, {
                            id: "doc",
                            name: "doc",
                            modelValue: _ctx.company.doc,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.company.doc = $event)),
                            url: _ctx.company.doc_path_url
                          }, null, 8, ["modelValue", "url"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Fieldset, { class: "p-mt-4" }, {
              legend: _withCtx(() => [
                _hoisted_21
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_FloatLabel, { label: "Business name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.company.business_name,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.company.business_name = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_FloatLabel, { label: "Business address" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.company.business_address,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.company.business_address = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_FloatLabel, { label: "Business city" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.company.business_city,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.company.business_city = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_FloatLabel, { label: "Business zip" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.company.business_zip,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.company.business_zip = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_FloatLabel, { label: "Business country" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.company.business_country,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.company.business_country = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            (_ctx.isCustomer && !_ctx.isNew)
              ? (_openBlock(), _createBlock(_component_Fieldset, {
                  key: 1,
                  class: "p-mt-4"
                }, {
                  legend: _withCtx(() => [
                    _hoisted_28
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_AppTable, {
                      ref: "dataTable",
                      "striped-rows": false,
                      filtersSchema: _ctx.filters,
                      service: _ctx.service,
                      onRowClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToDetail($event.data))),
                      onEdit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goToDetail($event))),
                      showHeader: false
                    }, {
                      columns: _withCtx(() => [
                        _createVNode(_component_Column, {
                          field: "name",
                          header: 'Name'
                        }),
                        _createVNode(_component_Column, {
                          field: "email",
                          header: 'Email'
                        }),
                        _createVNode(_component_Column, {
                          field: "phone",
                          header: 'Phone'
                        }),
                        _createVNode(_component_Column, {
                          field: "business_name",
                          header: 'Business Name'
                        }),
                        _createVNode(_component_Column, {
                          field: "business_address",
                          header: 'Business address'
                        }),
                        _createVNode(_component_Column, {
                          field: "business_city",
                          header: 'Business City'
                        }),
                        _createVNode(_component_Column, {
                          field: "business_country",
                          header: 'Business country'
                        })
                      ]),
                      _: 1
                    }, 8, ["filtersSchema", "service"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ]))
}